module.exports = __webpack_public_path__ + "img/email-error.95b99af9.svg";